import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import { LandingLayout } from '@/layout/components/app.landinglayout';
import { AuthLayout } from '@/layout/components/app.authlayout';
import { AuthGuard } from './shared/guards/auth.guard';
import { provideStates } from '@ngxs/store';
import {
    BranchGraphQLSchemaState,
    CreditBalanceGraphQLSchemaState,
    CreditCardlinkResponseGraphQLSchemaState,
    CreditContractGraphQLSchemaState,
    CreditGraphQLSchemaState,
    CustomerCalendarGraphQLSchema,
    CustomerCalendarGraphQLSchemaState,
    CustomerCalendarServiceGraphQLSchemaState,
    CustomerGraphQLSchemaState,
    DigitalClientCardGraphQLSchemaState,
    ElectronicCashRegisterGraphQLSchemaState,
    EntitySubjectInfoGraphQLSchemaState,
    GoodSaleSummaryGraphQLSchemaState,
    InvoiceDetailGraphQLSchemaState,
    InvoiceGraphQLSchemaState,
    InvoiceIssuerGraphQLSchemaState,
    InvoicePaymentGraphQLSchemaState,
    POSTerminalGraphQLSchemaState,
    POSTerminalResponseGraphQLSchemaState,
    ProductDepartmentGraphQLSchemaState,
    ProductGraphQLSchemaState,
    ProductPackageGraphQLSchemaState,
    ProductUnitTypeGraphQLSchemaState,
    SupplierGraphQLSchemaState,
    UserAPIInfoGraphQLSchemaState,
    VATCategoryGraphQLSchemaState
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';

export const appRoutes: Routes = [
    {
        path: '',
        component: LandingLayout,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('@www/landing/landing.component').then(
                        (c) => c.LandingComponent
                    )
            }
        ]
    },
    {
        path: 'portal',
        component: AppLayout,
        canActivate: [AuthGuard],

        children: [
            {
                path: 'inventory/services/services-cards',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import(
                        '@portal/inventory/services/z-services-cards/z-services-cards.component'
                    ).then((c) => c.ZServicesCardsComponent),
                data: { breadcrumb: 'Υπηρεσίες' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState
                    ])
                ]
            },
            {
                path: 'inventory/products/products-cards',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import(
                        '@portal/inventory/products/z-products-cards/z-products-cards.component'
                    ).then((c) => c.ZProductsCardsComponent),
                data: { breadcrumb: 'Ανταλλακτικά' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState
                    ])
                ]
            },
            // {
            //     path: 'inventory/products/services-cards',
            //     canActivate: [AuthGuard],
            //     loadComponent: () =>
            //         import(
            //             '@portal/inventory/products/z-products-cards/z-products-cards.component'
            //         ).then((c) => c.ZProductsCardsComponent),
            //     data: { breadcrumb: 'Υπηρεσίες' },
            //     providers: [
            //         provideStates([
            //             InvoiceGraphQLSchemaState,
            //             InvoiceDetailGraphQLSchemaState,
            //             GoodSaleSummaryGraphQLSchemaState,
            //             CustomerGraphQLSchemaState,
            //             ProductGraphQLSchemaState,
            //             BranchGraphQLSchemaState,
            //             DigitalClientCardGraphQLSchemaState,
            //             ProductPackageGraphQLSchemaState,
            //             BranchGraphQLSchemaState,
            //             VATCategoryGraphQLSchemaState,
            //             ProductUnitTypeGraphQLSchemaState,
            //             SupplierGraphQLSchemaState,
            //             POSTerminalGraphQLSchemaState,
            //             UserAPIInfoGraphQLSchemaState,
            //             InvoiceIssuerGraphQLSchemaState,
            //             InvoicePaymentGraphQLSchemaState,
            //             POSTerminalResponseGraphQLSchemaState,
            //             ProductDepartmentGraphQLSchemaState,
            //             EntitySubjectInfoGraphQLSchemaState
            //         ])
            //     ]
            // },
            {
                path: 'vehicles/vehicles-cards',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import(
                        '@portal/vehicles/vehicle-cards/z-vehicle-cards/z-vehicle-cards.component'
                    ).then((c) => c.ZVehicleCardsComponent),
                data: { breadcrumb: 'Καρτέλες Οχημάτων' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState
                    ])
                ]
            },
            {
                path: 'clients/cliens-list',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import(
                        '@portal/clients/clients-cards/clients-cards.component'
                    ).then((c) => c.ClientsCardsComponent),
                data: { breadcrumb: 'Επαφές' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState
                    ])
                ]
            },
            {
                path: 'clients/dcl-cards',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import(
                        '@portal/clients/dcl-cards/dcl-cards.component'
                    ).then((c) => c.DclCardsComponent),
                data: { breadcrumb: 'Ψηφιακό Πελατολόγιο' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState
                    ])
                ]
            },
            {
                path: 'invoicing/invoices-cards',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import(
                        '@portal/invoicing/invoices-cards/invoices-cards.component'
                    ).then((c) => c.InvoicesCardsComponent),
                data: { breadcrumb: 'Παραστατικά Πωλήσεων' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState
                    ])
                ]
            },
            {
                path: 'settings/credits',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import('@portal/settings/credits/credits.component').then(
                        (c) => c.CreditsComponent
                    ),
                data: { breadcrumb: 'Μονάδες' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState,

                        CreditGraphQLSchemaState,
                        CreditBalanceGraphQLSchemaState,
                        CreditContractGraphQLSchemaState,
                        CreditCardlinkResponseGraphQLSchemaState
                    ])
                ]
            },
            {
                path: 'settings/ecrs-cards',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import(
                        '@portal/settings/cash-registers/cash-registers-cards/z-cash-registers-cards/z-cash-registers-cards.component'
                    ).then((c) => c.ZCashRegistersCardsComponent),
                data: { breadcrumb: 'Ταμειακές Μηχανές' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState,

                        CreditGraphQLSchemaState,
                        CreditBalanceGraphQLSchemaState,
                        CreditContractGraphQLSchemaState,
                        CreditCardlinkResponseGraphQLSchemaState,

                        ElectronicCashRegisterGraphQLSchemaState
                    ])
                ]
            },
            {
                path: 'calendar',
                canActivate: [AuthGuard],
                loadComponent: () =>
                    import(
                        '@portal/calendar/z-calendar/z-calendar.component'
                    ).then((c) => c.ZCalendarComponent),
                data: { breadcrumb: 'Ημερολόγιο' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState,

                        CreditGraphQLSchemaState,
                        CreditBalanceGraphQLSchemaState,
                        CreditContractGraphQLSchemaState,
                        CreditCardlinkResponseGraphQLSchemaState,

                        ElectronicCashRegisterGraphQLSchemaState,
                        CustomerCalendarGraphQLSchemaState,
                        CustomerCalendarServiceGraphQLSchemaState
                    ])
                ]
            }
        ]
    },
    {
        path: 'payments',
        component: AuthLayout,
        children: [
            {
                path: 'payment-result-success',
                loadComponent: () =>
                    import(
                        '@portal/payments/payment-result-success/payment-result-success.component'
                    ).then((c) => c.PaymentResultSuccessComponent),
                data: { breadcrumb: 'Αγορά Μονάδων' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState,

                        CreditGraphQLSchemaState,
                        CreditBalanceGraphQLSchemaState,
                        CreditContractGraphQLSchemaState,
                        CreditCardlinkResponseGraphQLSchemaState
                    ])
                ]
            },

            {
                path: 'payment-result-failed',
                loadComponent: () =>
                    import(
                        '@portal/payments/payment-result-failed/payment-result-failed.component'
                    ).then((c) => c.PaymentResultFailedComponent),
                data: { breadcrumb: 'Αγορά Μονάδων' },
                providers: [
                    provideStates([
                        InvoiceGraphQLSchemaState,
                        InvoiceDetailGraphQLSchemaState,
                        GoodSaleSummaryGraphQLSchemaState,
                        CustomerGraphQLSchemaState,
                        ProductGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        DigitalClientCardGraphQLSchemaState,
                        ProductPackageGraphQLSchemaState,
                        BranchGraphQLSchemaState,
                        VATCategoryGraphQLSchemaState,
                        ProductUnitTypeGraphQLSchemaState,
                        SupplierGraphQLSchemaState,
                        POSTerminalGraphQLSchemaState,
                        UserAPIInfoGraphQLSchemaState,
                        InvoiceIssuerGraphQLSchemaState,
                        InvoicePaymentGraphQLSchemaState,
                        POSTerminalResponseGraphQLSchemaState,
                        ProductDepartmentGraphQLSchemaState,
                        EntitySubjectInfoGraphQLSchemaState,

                        CreditGraphQLSchemaState,
                        CreditBalanceGraphQLSchemaState,
                        CreditContractGraphQLSchemaState,
                        CreditCardlinkResponseGraphQLSchemaState
                    ])
                ]
            }
        ]
    },
    {
        path: 'ddd',
        component: AppLayout,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import(
                        '@/pages/dashboards/ecommerce/ecommercedashboard'
                    ).then((c) => c.EcommerceDashboard),
                data: { breadcrumb: 'E-Commerce Dashboard' }
            },
            {
                path: 'dashboard-banking',
                loadComponent: () =>
                    import('@/pages/dashboards/banking/bankingdashboard').then(
                        (c) => c.BankingDashboard
                    ),
                data: { breadcrumb: 'Banking Dashboard' }
            },
            {
                path: 'dashboard-marketing',
                loadComponent: () =>
                    import(
                        '@/pages/dashboards/marketing/marketingdashboard'
                    ).then((c) => c.MarketingDashboard),
                data: { breadcrumb: 'Marketing Dashboard' }
            },
            {
                path: 'uikit',
                data: { breadcrumb: 'UI Kit' },
                loadChildren: () => import('@/pages/uikit/uikit.routes')
            },
            {
                path: 'documentation',
                data: { breadcrumb: 'Documentation' },
                loadComponent: () =>
                    import('@/pages/documentation/documentation').then(
                        (c) => c.Documentation
                    )
            },
            {
                path: 'pages',
                loadChildren: () => import('@/pages/pages.routes'),
                data: { breadcrumb: 'Pages' }
            },
            {
                path: 'apps',
                loadChildren: () => import('@/apps/apps.routes'),
                data: { breadcrumb: 'Apps' }
            },

            {
                path: 'blocks',
                data: { breadcrumb: 'Free Blocks' },
                loadChildren: () => import('@/pages/blocks/blocks.routes')
            },
            {
                path: 'ecommerce',
                loadChildren: () =>
                    import('@/pages/ecommerce/ecommerce.routes'),
                data: { breadcrumb: 'E-Commerce' }
            },
            {
                path: 'profile',
                loadChildren: () =>
                    import('@/pages/usermanagement/usermanagement.routes')
            }
        ]
    },
    {
        path: 'landing',
        component: LandingLayout,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('@www/landing/landing.component').then(
                        (c) => c.LandingComponent
                    )
            },
            {
                path: 'old',
                loadComponent: () =>
                    import('@/pages/landing/landingpage').then(
                        (c) => c.LandingPage
                    )
            },
            {
                path: 'features',
                loadComponent: () =>
                    import('@/pages/landing/featurespage').then(
                        (c) => c.FeaturesPage
                    )
            },
            {
                path: 'pricing',
                loadComponent: () =>
                    import('@/pages/landing/pricingpage').then(
                        (c) => c.PricingPage
                    )
            },
            {
                path: 'contact',
                loadComponent: () =>
                    import('@/pages/landing/contactpage').then(
                        (c) => c.ContactPage
                    )
            }
        ]
    },

    {
        path: 'auth',
        component: AuthLayout,
        children: [
            // {
            //     path: 'login',
            //     loadComponent: () =>
            //         import('@/pages/auth/login').then((c) => c.Login)
            // },
            {
                path: 'login',
                loadComponent: () =>
                    import('@portal/auth/login').then((c) => c.Login)
            },
            {
                path: 'register',
                loadComponent: () =>
                    import('@/pages/auth/register').then((c) => c.Register)
            },
            {
                path: 'verification',
                loadComponent: () =>
                    import('@/pages/auth/verification').then(
                        (c) => c.Verification
                    )
            },
            {
                path: 'forgot-password',
                loadComponent: () =>
                    import('@/pages/auth/forgotpassword').then(
                        (c) => c.ForgotPassword
                    )
            },
            {
                path: 'new-password',
                loadComponent: () =>
                    import('@/pages/auth/newpassword').then(
                        (c) => c.NewPassword
                    )
            },
            {
                path: 'lock-screen',
                loadComponent: () =>
                    import('@/pages/auth/lockscreen').then((c) => c.LockScreen)
            },
            {
                path: 'access',
                loadComponent: () =>
                    import('@/pages/auth/access').then((c) => c.Access)
            },
            {
                path: 'oops',
                loadComponent: () =>
                    import('@/pages/oops/oops').then((c) => c.Oops)
            },
            {
                path: 'error',
                loadComponent: () =>
                    import('@/pages/notfound/notfound').then((c) => c.Notfound)
            }
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: '**', redirectTo: '/auth/login' }
];
